export default __webpack_public_path__ + "static/media/star-dark-icon.8ea7de91.svg";